import { registerBeginnerLoopBlocks as defineLoopBlocks } from './loop-blocks.js';

let registered = false;

export function registerBeginnerLoopBlocks(): void {
  if (registered) {
    return;
  }
  defineLoopBlocks();
  registered = true;
}
